var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD1Pyronanometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.58 38a2 2 0 01-2 2h-4.04a2 2 0 010-4h4.08a2 2 0 011.96 2zM54.4 48.84a2.001 2.001 0 00-2.83 2.83l2.89 2.88a2.001 2.001 0 002.83-2.83l-2.89-2.88zm0-21.68l2.89-2.88a2.001 2.001 0 00-2.83-2.83l-2.89 2.88a2.001 2.001 0 002.83 2.83zM40 22.7V27a11.84 11.84 0 010 21.15v4.34a15.84 15.84 0 000-29.79zm2 31.76a2 2 0 00-2 2v4.04a2 2 0 004 0v-4.08a2 2 0 00-2-1.96zM42 20a2 2 0 002-2v-4a2 2 0 00-4 0v4a2 2 0 002 2zM32 69h4V7h-4v62zM16.25 38A16.73 16.73 0 0027 53.61V22.39A16.73 16.73 0 0016.25 38z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/D1_Pyronanometer.5ee5f04d.svg";
export { SvgD1Pyronanometer as ReactComponent };